/* shop/AddProductEbook.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_dev,
	listen_dev,
	noop,
	safe_not_equal,
	text,
	validate_slots
} from "svelte/internal";

import basketStore from "./basketStore";
const file = "shop/AddProductEbook.svelte";

function create_fragment(ctx) {
	let div;
	let button;
	let t;
	let button_data_tooltiptext_value;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			div = element("div");
			button = element("button");
			t = text("E+");
			attr_dev(button, "type", "button");
			attr_dev(button, "class", "addProductPrintBtn tooltip tooltip-top");
			attr_dev(button, "data-tooltiptext", button_data_tooltiptext_value = "Přidat do košíku ebook za " + /*price*/ ctx[1].toLocaleString() + " Kč");
			add_location(button, file, 26, 4, 474);
			attr_dev(div, "class", "addProductPrintWrap");
			add_location(div, file, 25, 0, 436);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, div, anchor);
			append_dev(div, button);
			append_dev(button, t);

			if (!mounted) {
				dispose = listen_dev(button, "click", /*click_handler*/ ctx[3], false, false, false, false);
				mounted = true;
			}
		},
		p: noop,
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

const quantity = 1;

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('AddProductEbook', slots, []);
	let { elm } = $$props;

	// ziskani dat z HTML
	const data = JSON.parse(elm.dataset.addProduct);

	// data ebook
	const ebook = data.ebook ? data.ebook : null;

	const price = quantity * ebook.unit_price;

	$$self.$$.on_mount.push(function () {
		if (elm === undefined && !('elm' in $$props || $$self.$$.bound[$$self.$$.props['elm']])) {
			console.warn("<AddProductEbook> was created without expected prop 'elm'");
		}
	});

	const writable_props = ['elm'];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<AddProductEbook> was created with unknown prop '${key}'`);
	});

	const click_handler = () => basketStore.insertProduct(ebook, quantity);

	$$self.$$set = $$props => {
		if ('elm' in $$props) $$invalidate(2, elm = $$props.elm);
	};

	$$self.$capture_state = () => ({
		basketStore,
		elm,
		data,
		ebook,
		quantity,
		price
	});

	$$self.$inject_state = $$props => {
		if ('elm' in $$props) $$invalidate(2, elm = $$props.elm);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [ebook, price, elm, click_handler];
}

class AddProductEbook extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, { elm: 2 });

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "AddProductEbook",
			options,
			id: create_fragment.name
		});
	}

	get elm() {
		throw new Error("<AddProductEbook>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set elm(value) {
		throw new Error("<AddProductEbook>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default AddProductEbook;